import { UUID } from '@cmg/common';

import { useIsUserSettlementAgent } from '../../../../../common/hooks/useIsUserSettlementAgent/useIsUserSettlementAgent';
import useCheckRetailIndicationAccess from '../../../../../common/util/check-access/useCheckRetailIndicationAccess';
import routeFactory from '../../../../../common/util/routeFactory';
import { ReactRouterDomainNavTabProps } from '../../../../../design-system/react-router/ReactRouterDomainNavTab';

export type Props = Readonly<{ offeringId: UUID; isInternalOffering?: boolean }>;

export const useTotalRetailDemandRoute = ({
  offeringId,
  isInternalOffering,
}: Props): ReactRouterDomainNavTabProps | null => {
  const { isSettlementAgent } = useIsUserSettlementAgent({ offeringId });

  const { canRead: canReadRetailIndication } = useCheckRetailIndicationAccess({ offeringId });

  const href = routeFactory.orderBookTotalRetailDemand.getUrlPath({ offeringId });

  if (!canReadRetailIndication || (!isSettlementAgent && !isInternalOffering)) {
    return null;
  }

  return {
    href,
    label: 'Total Retail Demand',
  };
};
